<!-- mobile only, docked bottom, safe-area, shadow, rounded-2xl -->
<nav *ngIf="isMobile() && !(hideOnKeyboard && kbOpen())"
     class="fixed bottom-0 left-0 right-0 z-[60] px-3"
     [class.pointer-events-none]="false">

  <div class="mx-auto max-w-screen-sm rounded-2xl
           flex items-stretch justify-between gap-1
           py-1.5 pb-[calc(env(safe-area-inset-bottom,0px)+6px)]
           select-none"
       [ngClass]="[palette.bg, palette.ring, palette.shadow]">

    <ng-container *ngFor="let it of items">
      <!-- Liens normaux (hors info & settings) -->
      <a *ngIf="it.key !== 'settings' && it.key !== 'info'"
         [routerLink]="buildLink(it)"
         class="flex-1 px-2 py-1.5 flex flex-col items-center justify-center text-center
                transition-transform active:scale-[0.98]"
         [attr.aria-current]="isActive(buildLink(it)) ? 'page' : null"
         [ngClass]="isActive(buildLink(it)) ? palette.active : [palette.idle, palette.hover]">

        <!-- Icônes -->
        <span class="block" aria-hidden="true">
          <!-- swap -->
          <svg *ngIf="it.icon==='i-swap'" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M7 7h10l-3-3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M17 17H7l3 3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <!-- bridge (nouvelle icône) -->
          <svg *ngIf="it.icon==='i-bridge'"
               class="w-6 h-6 opacity-90 group-hover:opacity-100 transition-opacity"
               viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <!-- Tablier -->
            <path d="M4 6h16" stroke-width="1.4" stroke-linecap="round" />
            <!-- Colonnes -->
            <path d="M6 6v12M18 6v12"
                  stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <!-- Bases -->
            <path d="M5 20h2M17 20h2"
                  stroke-width="1.2" stroke-linecap="round" />
          </svg>

          <!-- blog -->
          <svg *ngIf="it.icon==='i-blog'" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <rect x="5" y="4" width="14" height="16" rx="2" stroke-width="1.5"></rect>
            <path d="M8 8h8M8 12h8M8 16h5" stroke-width="1.5" stroke-linecap="round"></path>
          </svg>
        </span>

        <span class="mt-0.5 text-[10px] font-medium leading-none tracking-wide">
          {{ it.labelKey | translate }}
        </span>
      </a>

      <!-- Bouton Info (ouvre le sous-menu côté parent) -->
      <button *ngIf="it.key === 'info'"
              type="button"
              (click)="infoClick.emit()"
              class="flex-1 px-2 py-1.5 flex flex-col items-center justify-center text-center
                     transition-transform active:scale-[0.98]"
              [ngClass]="[palette.idle, palette.hover]">
        <span class="block" aria-hidden="true">
          <!-- icône info (identique visuel) -->
          <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="9" stroke-width="1.5"></circle>
            <path d="M12 10v7" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M12 7.5h.01" stroke-width="2" stroke-linecap="round"></path>
          </svg>
        </span>
        <span class="mt-0.5 text-[10px] font-medium leading-none tracking-wide">
          {{ it.labelKey | translate }}
        </span>
      </button>

      <!-- Bouton Paramètres (ouvre <app-settings> côté parent) -->
      <button *ngIf="it.key === 'settings'"
              type="button"
              (click)="settingsClick.emit()"
              class="flex-1 px-2 py-1.5 flex flex-col items-center justify-center text-center
                     transition-transform active:scale-[0.98]"
              [ngClass]="[palette.idle, palette.hover]">
        <span class="block" aria-hidden="true">
          <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <!-- noyau -->
            <circle cx="12" cy="12" r="3"></circle>
            <!-- dents de l'engrenage -->
            <path d="M19.4 15a1.7 1.7 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.82-.33
           1.7 1.7 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.7 1.7 0 0 0-1-1.51
           1.7 1.7 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15
           1.7 1.7 0 0 0 3.09 13H3a2 2 0 0 1 0-4h.09A1.7 1.7 0 0 0 4.6 7
           a1.7 1.7 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 8.59 3.9
           c.69 0 1.29-.4 1.51-1V3a2 2 0 0 1 4 0v.09c.22.6.82 1 1.51 1
           .68 0 1.28-.4 1.51-1l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06
           c-.3.3-.4.9-.33 1.82.08.9.62 1.5 1.51 1.51H21a2 2 0 0 1 0 4h-.09
           c-.9.01-1.44.61-1.51 1.51Z" />
          </svg>
        </span>
        <span class="mt-0.5 text-[10px] font-medium leading-none tracking-wide">
          {{ it.labelKey | translate }}
        </span>
      </button>
    </ng-container>

  </div>
</nav>
